// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M8 12L12 8L8 4M12 8H4'];
